module.exports = __webpack_public_path__ + "img/mc_symbol.543bc93b.svg";